import React from 'react';
import { stats } from '../data/mock';
import {
  School,
  Users,
  GraduationCap,
  MapPin,
  Shield,
  Headphones
} from 'lucide-react';

const iconMap = {
  School: School,
  Users: Users,
  GraduationCap: GraduationCap,
  MapPin: MapPin,
  Shield: Shield,
  Headphones: Headphones
};

const StatsSection = () => {
  return (
    <section className="relative py-16 bg-white">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-teal-500 via-cyan-500 to-teal-500" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {stats.map((stat, index) => {
            const IconComponent = iconMap[stat.icon];
            return (
              <div
                key={stat.id}
                className="text-center group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-teal-50 to-cyan-50 mb-4 group-hover:scale-110 transition-transform duration-300">
                  {IconComponent && (
                    <IconComponent className="w-7 h-7 text-teal-600" />
                  )}
                </div>
                <div className="text-3xl font-bold text-slate-800 mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-slate-500 font-medium">
                  {stat.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
